import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Stack from '@mui/material/Stack';

import {
  getCampaignBanner,
  getCampaignBrandFontColor,
  getUseCampaignBanner
} from '../../../redux/modules/campaignLandingPage';
import { VpIcon } from '../VpIcon';
import { StyledVpLink } from './styles';

import { SocialMediaOptions } from '../../../constants/element-types';

const SocialMediaElement = ({ elements = [], color = '', backgroundColor, useBanner = false }) => {
  const CleanedElements = elements?.filter((e) => SocialMediaOptions?.includes(e?.value));

  return (
    <Stack direction="row" gap="10px" alignItems="center" justifyContent="center" my="15px">
      {CleanedElements?.map((element, key) => (
        <StyledVpLink
          to={{ pathname: element?.mediaUrl }}
          target={'_blank'}
          key={key}
          backgroundColor={backgroundColor}
          color={color}
          custom={useBanner}
        >
          <VpIcon icon={element?.value} size={15} />
        </StyledVpLink>
      ))}
    </Stack>
  );
};

SocialMediaElement.propTypes = {
  elements: PropTypes.array,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state) => ({
  backgroundColor: getCampaignBanner(state),
  color: getCampaignBrandFontColor(state),
  useBanner: getUseCampaignBanner(state)
});

export default connect(mapStateToProps)(SocialMediaElement);



// WEBPACK FOOTER //
// ./src/vp-ui/components/SocialMediaElement/SocialMediaElement.jsx